import { AppBaseUrl } from "./config/env";

const genericError = {
  message: "Sorry, we’re unable to value your vehicle right now.",
  innerMessage: "Something's gone wrong. Please try again later.",
  btnlabel: "Return to homepage"
};

const vehicleNotFound = {
  message: "Sorry, we're having trouble finding that vehicle.",
  innerMessage: "Please check your registration and try again.",
  btnlabel: "Enter registration",
  redirectUrl: `${AppBaseUrl}/registration`
};

const valueTooHigh = {
  message: "Sorry, we’re unable to value your vehicle right now.",
  innerMessage:
    "We're not currently buying cars of this value right now. The good news is, you can use this car as a part-exchange.",
  btnlabel: "Continue",
  linkCopy: "What is part-exchange?",
  linkUrl:
    "https://www.arnoldclark.com/car-valuation/part-exchange#how_it_works"
};

export const errors = {
  VAL: genericError,
  "VA-A-NF": genericError,
  "V-NF": vehicleNotFound,
  "VA-V-NF": genericError,
  "VAL-ESSM": valueTooHigh,
  default: genericError
};

export const getErrorMessage = (code) => errors[code] || errors.default;

export default class CustomException {
  constructor(response) {
    this.error = response;
  }
}

export const isErrorVehicleNotFound = (err) => err === "V-NF";
export const isErrorVehicleCapDataNotFound = (err) => err === "V-NO-CAP";
export const isErrorVehicleNotEligibleForValuation = (err) => err === "V-NEFV";
export const isErrorOnlineValuationUnavailable = (err) => err === "ON-VAL-UA";
export const isErrorBlockedRegistration = (err) => err === "NAW";

export const isHandledVehicleErrorCode = (errorCode) =>
  isErrorVehicleNotFound(errorCode) ||
  isErrorVehicleCapDataNotFound(errorCode) ||
  isErrorVehicleNotEligibleForValuation(errorCode) ||
  isErrorBlockedRegistration(errorCode);
